import { Map } from 'immutable'

export const ReducerRecord = Map()
